import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ConferenciaVolume,
  ConferenciaVolumesTotaisDetalhes,
  RequestAcompanhamentoRemessaProdutoRisco,
  RequisicaoConfVolumeTotal,
  RequisicaoTotalProduto,
  ResponseAcompanhamentoRemessaProdutoRisco,
  totalProdutos
} from 'src/app/@shared/models/confVolume';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filter = (obj) => {
  return `${obj.loteID ? `loteID=${obj.loteID}&` : ''}` +
    `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
    `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
};

@Injectable({
  providedIn: 'root'
})
export class ConferenciaVolumeService {

  constructor(private http: HttpClient) { }

  confVolumeTotal(obj: RequisicaoConfVolumeTotal): Observable<ConferenciaVolume[]> {
    const filter = `${obj.dtIni ? `dtIni=${obj.dtIni}&` : ''}` +
      `${obj.dtFim ? `dtFim=${obj.dtFim}&` : ''}` +
      `${obj.numMovimento ? `numMovimento=${obj.numMovimento}&` : ''}` +
      `${obj.filialId ? `filialId=${obj.filialId}&` : ''}` +
      `${obj.clienteID ? `clienteID=${obj.clienteID}&` : ''}` +
      `${obj.produtoIDs ? `produtoIDs=${obj.produtoIDs}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<ConferenciaVolume[]>(
      `ConferenciaVolumes/ConferenciaVolumesTotais?${filter}`,
      httpOptions
    );
  }

  confVolumeDetalhes(obj: RequisicaoTotalProduto): Observable<ConferenciaVolumesTotaisDetalhes[]> {
    return this.http.get<ConferenciaVolumesTotaisDetalhes[]>(
      `ConferenciaVolumes/ConferenciaVolumesTotaisDetalhes?${filter(obj)}`,
      httpOptions
    );
  }

  confVolumeRemessa(loteId?: number): Observable<any> {
    return this.http
      .get<any>(`ConferenciaVolumes/ConferenciaVolumesTotais/AcompanhamentoRemessa?loteId=${loteId}`, httpOptions);
  }

  confVolumeTotalPedidos(obj: RequisicaoTotalProduto): Observable<totalProdutos[]> {
    const filter = `${obj.loteID ? `loteID=${obj.loteID}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<totalProdutos[]>(
      `ConferenciaVolumes/ConferenciaVolumesTotais/AcompanhamentoRemessaTotalPedidos?${filter}`,
      httpOptions
    );
  }
  
  confVolumeTotalPedidosRecepcionados(obj: RequisicaoTotalProduto): Observable<totalProdutos[]> {
    const filter = `${obj.loteID ? `loteID=${obj.loteID}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<totalProdutos[]>(
      `ConferenciaVolumes/ConferenciaVolumesTotais/AcompanhamentoRemessaTotalPedidosRecepcionados?${filter}`,
      httpOptions
    );
  }

  confVolumeTotalPedidosNaoRecepcionados(obj: RequisicaoTotalProduto): Observable<totalProdutos[]> {
    const filter = `${obj.loteID ? `loteID=${obj.loteID}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<totalProdutos[]>(
      `ConferenciaVolumes/ConferenciaVolumesTotais/AcompanhamentoRemessaTotalPedidosNaoRecepcionados?${filter}`,
      httpOptions
    );
  }
  
  acompanhamentoRemessaProdutoRisco(obj: RequestAcompanhamentoRemessaProdutoRisco): 
    Observable<ResponseAcompanhamentoRemessaProdutoRisco[]> {
      return this.http.get<ResponseAcompanhamentoRemessaProdutoRisco[]>(
        `ConferenciaVolumes/ConferenciaVolumesTotais/AcompanhamentoRemessaProdutoRisco?${filter(obj)}`,
        httpOptions
      );
  }

  ListarClientesRisco(): Observable<any> {
    return this.http.get<any>(
      `ConferenciaVolumes/ConferenciaVolumesTotais/ListarClientesRisco`, httpOptions);
  }

  transformarProdutoEmRisco(loteID: number): Observable<any> {
    return this.http.post<any>(
      `ConferenciaVolumes/ConferenciaVolumesTotais/TransformarProdutoEmRisco`, { loteID }, httpOptions);
  }

  rollbackTransformarProdutoEmRisco(loteID: number): Observable<any> {
    return this.http.post<any>(
      `ConferenciaVolumes/ConferenciaVolumesTotais/RollbackTransformarProdutoEmRisco`, { loteID }, httpOptions
    );
  }

  public exportarExcel(obj: any): Observable<any> {
    const filterExcel = `${obj.dtIni ? `dtIni=${obj.dtIni}&` : ''}` +
    `${obj.dtFim ? `dtFim=${obj.dtFim}&` : ''}` +
    `${obj.numMovimento ? `numMovimento=${obj.numMovimento}&` : ''}` +
    `${obj.filialId ? `filialId=${obj.filialId}&` : ''}` +
    `${obj.clienteID ? `clienteID=${obj.clienteID}&` : ''}` +
    `${obj.produtoIDs ? `produtoIDs=${obj.produtoIDs}&` : ''}` +
    `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
    `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<any>(`ConferenciaVolumes/ConferenciaVolumesTotais/exportar?${filterExcel}`, httpOptions); 
  }

  public exportarExcelDetalhesLote(obj: any): Observable<any> {
    const filterExcel = `${obj.loteID ? `loteID=${obj.loteID}&` : ''}` +
    `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
    `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<any>(`ConferenciaVolumes/ConferenciaVolumesTotaisDetalhes/Exportar?${filterExcel}`, httpOptions);
  }

  public exportarExcelAcompRemessa(LoteId: number): Observable<any> {
    return this.http.get<any>(`ConferenciaVolumes/ConferenciaVolumesTotais/AcompanhamentoRemessa/Exportar?LoteId=${LoteId}`, httpOptions);
  }

}
